import { pathData } from "./animatedChiliPaths"

const AnimatedChili = ({ classes, animation }) => {
    const chiliColor = "#f0573e"
    return (
        <div className={classes}>
            <svg
                className="w-auto h-full max-h-full max-w-full mx-auto"
                width="2029"
                height="2000"
                viewBox="0 0 2029 1000"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g>
                    {pathData.map((path, index) => (
                        <path
                            key={index}
                            d={path}
                            fill={chiliColor}
                            className={animation}
                        />
                    ))}
                </g>
            </svg>
        </div>
    )
}

export default AnimatedChili
